import React from 'react';
import getInitialPropsForServicePage from 'helpers/services/getServiceProps';
import { MID_LEVEL_SERVICE_PAGE } from 'constants/Services';
import { MidLevelServicePage } from 'views/Services/';
import configureStore from 'state/configureStore';
import getServerSidePropsWrapper from 'helpers/getServerSidePropsWrapper';

export const Ensemble = (props) => <MidLevelServicePage {...props} />;

export const getServerSideProps = configureStore.getServerSideProps(
  (store) => async (ctx) =>
    await getServerSidePropsWrapper({ ...ctx, store }, async (ctx) => {
      const { req, res } = ctx;
      return await getInitialPropsForServicePage(
        res,
        store,
        { serviceSlug: 'ensemble' },
        MID_LEVEL_SERVICE_PAGE,
        req
      );
    })
);

export default Ensemble;
